<template>
  <div>
    
    <!-- 更换邮箱 -->
    <el-dialog class="wrap" :visible.sync="changeEmailVisible" :before-close="change_email_dialog_close" append-to-body>
      <el-form label-width="100px">
        <el-form-item label="新邮箱" prop="email">
          <el-input v-model="email" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="changeEmailVisible = false">取消</el-button>
        <el-button type="primary" @click.native="handleSubmit">提交</el-button>
      </div>
    </el-dialog>

    <hr color="B3C3EC">
    <div class="email">{{fantasyUserBO.email}}</div>
    <div class="content">
    　  您的邮箱还未经过验证。如果距离您上次发送验证邮件超过1小时，请 <el-button type="primary" plain size="mini" :disabled="isDisable" @click="sendVerifyEmail();">{{buttonStr}}</el-button>
    或<el-button type="primary" plain size="mini" @click="showChangeEmail();">更换邮箱</el-button> 重新验证。
    <hr color="B3C3EC">
    　  也可以直接输入验证邮件中的6位数字验证码完成验证：<br/>
    <div class="code-row">
      <el-input class="code-input" v-model="emailNumCode" maxlength="6" placeholder="6位数字验证码" @keyup.enter.native="verifyByEmailCode();"></el-input>
      <el-button type="primary" size="mini" :loading="verifyLoading" @click="verifyByEmailCode();">验 证</el-button>
    </div>
    <hr color="B3C3EC">
    </div>
    <el-footer class="footer">
      <el-row>
        <el-col :span="24">
          <div class="copyright">
            ©Copyright 2019 <a href="http://www.huanzhidadi.com" target="_blank">幻之大地</a> ALL RIGHTS RESERVED. <a href="https://beian.miit.gov.cn" target="_blank" title="豫ICP备17045248号-3">豫ICP备17045248号-3</a>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <div class="advice">
            抵制不良游戏，拒绝盗版游戏。注意自我保护，谨防受骗上当。<br/>适度游戏益脑，沉迷游戏伤身。合理安排时间，享受健康生活。
          </div>
        </el-col>
      </el-row>
    </el-footer>
  </div>
</template>
<script>
  import {postRequest} from '../../utils/api'
  import {getRequest} from '../../utils/api'
  import Message from 'element-ui/lib/message'
  export default{
  data(){
    return {
      isDisable: false,
      buttonStr: "点击重发",
      fantasyUserBO: {},
      changeEmailVisible: false,
      email: "",
      emailNumCode: "",
      verifyLoading: false
    }
  },
    mounted: function () {
      this.getUserInfo();
    },
    methods: {
      change_email_dialog_close() {
          this.changeEmailVisible = false;
      },
      showChangeEmail: function() {
        this.changeEmailVisible = true;
      },
      handleSubmit: function() {
        if (this.email == "") {
          Message.error("请输入新邮箱地址。");
        }
        
        postRequest('/user/user/changeUserEmail', {
          email: this.email
        }).then(resp=> {
          if (resp.status == 200) {
          //成功
          var respData = resp.data;
          if (200 == respData.status) {
            this.$store.commit('user/SET_FANTASY_USER', respData.data);
            this.fantasyUserBO = respData.data;
            Message.success(respData.message);
            this.sendVerifyEmail();
            this.changeEmailVisible = false;
          } else {
            Message.error(respData.message);
          }
          } else {
          //失败
          Message.error('用户非法⊙﹏⊙∥!');
          }
        }, resp=> {
          Message.error('用户非法⊙﹏⊙∥!');
        });
      },
      getUserInfo: function() {
        var _this = this;
        getRequest('/user/user/getUserInfo', {
        }).then(resp=> {
            if (resp.status == 200) {
            //成功
            var respData = resp.data;
            if (200 == respData.status) {
                _this.fantasyUserBO = respData.data;
            } else {
                Message.error(respData.message);
            }
            } else {
            //失败
            Message.error('用户非法⊙﹏⊙∥!1');
            }
        }, resp=> {
            Message.error('用户非法⊙﹏⊙∥!2');
        });
      },
      sendVerifyEmail: function() {
        this.isDisable = true;  //开始可以点击
        postRequest('/auth/login/createVerifyMail', {
        }).then(resp=> {
          if (resp.status == 200) {
            //成功
            var respData = resp.data;
            if (200 == respData.status) {
              this.buttonStr = "已发送";
            } else {
              Message.error(respData.message);
              this.$router.replace({path: '/'});
            }
          } else {
          //失败
          Message.error('用户非法⊙﹏⊙∥!');
          this.$router.replace({path: '/'});
          }
        }, resp=> {
          Message.error('用户非法⊙﹏⊙∥!');
          this.$router.replace({path: '/'});
        });
      },
      //输入邮件中的6位数字验证码完成验证
      verifyByEmailCode: function() {
        var _this = this;
        var code = (this.emailNumCode || '').trim();
        if (code == "") {
          Message.error('请输入邮件中的6位验证码。');
          return;
        }
        if (!/^\d{6}$/.test(code)) {
          Message.error('验证码应为6位数字。');
          return;
        }
        this.verifyLoading = true;
        postRequest('/auth/mail/verifyUserEmailByCode', {
          emailNumCode: code
        }).then(resp=> {
          _this.verifyLoading = false;
          if (resp.status == 200) {
            var respData = resp.data;
            if (respData && respData.status == 200) {
              Message.success(respData.message || '邮箱验证成功，请重新登陆。');
              _this.$router.replace({path: '/'});
            } else {
              Message.error((respData && respData.message) || '验证失败，请稍后再试。');
            }
          } else {
            Message.error('网络异常，请稍后再试。');
          }
        }, resp=> {
          _this.verifyLoading = false;
          Message.error('网络异常，请稍后再试。');
        });
      }
    }
  }
  
</script>
<style scoped>
  .email {
    font-size: 2em;
    color:#FF0000;
    line-height: 2em;
    text-align: center;
  }
  .code-row {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    margin: 10px auto;
    max-width: 320px;
  }
  .code-input {
    flex: 1;
  }
  .code-input >>> .el-input__inner {
    text-align: center;
    letter-spacing: 4px;
  }
  .content a {
    cursor: pointer;
    color: blue;
    text-decoration:none;
  }
  .content a:hover {text-decoration:underline;color:#FF0000}
  .content {
    line-height: 2em;
    text-align: center;
  }
  
.footer a {
    cursor: pointer;
    color: #333;
    text-decoration:none;
}
.footer a:hover {text-decoration:underline;color:#FF0000}
.footer .copyright {
  margin: 5px auto;
  text-align: center;
  font-size: 14px;
  color: #333;
}
.footer .advice {
  margin: 0;
  text-align: center;
  font-size: 12px;
  color: #444;
}
</style>
